import { render, staticRenderFns } from "./record_details.vue?vue&type=template&id=2f00c5af&scoped=true&"
import script from "./record_details.vue?vue&type=script&lang=js&"
export * from "./record_details.vue?vue&type=script&lang=js&"
import style0 from "./record_details.vue?vue&type=style&index=0&id=2f00c5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f00c5af",
  null
  
)

export default component.exports